import { createApp } from 'vue'
// import ''
import App from './app'
import bus from '../composables/use-bus'
import { pinia } from '../store'

const app = createApp(App)
app.use(pinia)
app.mount('#app')

declare global {
  interface Window {
    dataLayer: {
      push: (evt: any) => void
    }
    ec: {
      dialog: {
        tips: (msg: any, el: any, params: any) => void
        closeAll: (msg: any) => void
      }
    }
    RestartTimeoutTimer: () => void
    $: any
    APEvent: {
      on: (name: string, callback: any) => void
      emit: (name: string) => void
    }
    ShowLoginAndResisterDIV: (
      func: string,
      key: string,
      href: string,
      source: string
    ) => void
  }
}

window.loginCallback = () => bus.emit('loginCallback')
window.loginCallbackAddtoCart = () => bus.emit('loginCallbackAddtoCart')
